window.addEventListener("load", function () {
    let okeClick = document.querySelector(".oke-questionslink"); // Custom button to trigger action
    let secondNavBarItems = document.querySelector(".oke-w-navBar-item:nth-of-type(2)"); // Navbar items
    secondNavBarItems.id = "scroll-on-question-tab";
  console.log(secondNavBarItems);
      // Ensure okeClick exists before attaching the event listener
      if (okeClick && secondNavBarItems) {
          okeClick.addEventListener('click', function(event) {
              event.preventDefault(); // Prevent default anchor click behavior
              const questionsTab = secondNavBarItems; // Second navbar item ("Questions" tab)
  
              // Ensure the "Questions" tab exists before trying to interact with it
              if (questionsTab) {
                  questionsTab.click();
              }
          });
      } else {
          console.log("Error: Custom button or second navbar item not found.");
      }
});